import { render } from "./defaultHotspot.vue?vue&type=template&id=0515fc1d"
import script from "./defaultHotspot.vue?vue&type=script&lang=js"
export * from "./defaultHotspot.vue?vue&type=script&lang=js"

import "./defaultHotspot.vue?vue&type=style&index=0&id=0515fc1d&lang=scss"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__